import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import BackButton from '../components/BackButton';

export default function AddBusiness() {
  const { parentCompany } = useAuth();
  const navigate = useNavigate();
  const [name, setName]     = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Business name is required'); return; }
    setSaving(true);
    setError('');
    try {
      await companyAPI.addBiz({ name: name.trim() });
      navigate('/company');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add business');
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <BackButton />
      <h1 className="page-title">Add Business</h1>
      <p className="text-muted" style={{ marginBottom: '1.5rem' }}>
        Add a new business under {parentCompany?.name || 'your company'}.
      </p>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div>
            <label style={{ fontSize: '0.85rem', color: 'var(--color-muted)', display: 'block', marginBottom: '0.35rem' }}>
              Business name
            </label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. Phiri Hardware Store"
              style={{ width: '100%' }}
              autoFocus
              required
            />
          </div>
          <p style={{ fontSize: '0.78rem', color: 'var(--color-muted)', margin: 0 }}>
            This business will use <strong>{parentCompany?.currency}</strong> and appear in your consolidated financials immediately.
          </p>
        </div>

        {error && <p style={{ color: 'var(--color-danger)', fontSize: '0.85rem', margin: 0 }}>{error}</p>}

        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? 'Adding…' : 'Add Business'}
        </button>
      </form>
    </div>
  );
}
